// Delete error-fallback folder when cleanup jql-builder-anonymized-jql-in-errors_kqkw9 ff

import React, { type ReactNode } from 'react';
import Button from '@atlaskit/button';
import { Box, xcss } from '@atlaskit/primitives';
import SectionMessage from '@atlaskit/section-message';
import { useIntl } from '@atlassian/jira-intl';
import messages from './messages';

export const JQLBuilderErrorFallback = () => {
	const { formatMessage } = useIntl();

	return (
		<Box xcss={wrapperStyles}>
			<SectionMessage appearance="error">
				{formatMessage(messages.errorMessage, {
					link: (linkText: ReactNode[]) => (
						<Button appearance="link" spacing="none" onClick={() => window.location.reload()}>
							{linkText}
						</Button>
					),
				})}
			</SectionMessage>
		</Box>
	);
};

const wrapperStyles = xcss({
	marginBottom: 'space.0',
});
